<template>
  <div class="fixed-right">
    <div class="item" v-for="item in ewmList" :key="item.id">
      <span class="icon">
        <img :src="item.small_image | baseImg" class="icon-img" />
      </span>
      <div class="ewm active">
        <img :src="item.ewm_image | baseImg" class="img" />
        <span class="tit">{{ item.title }} 扫码关注</span>
      </div>
    </div>

    <div class="item" v-for="(item, i) in list2" :key="item.small_image">
      <a
        class="icon text"
        :class="[`icon-color-${i}`]"
        :href="item.url"
        target="_blank"
        :title="item.title"
      >
        <!-- <img :src="item.small_image | baseImg" class="icon-img" /> -->
        {{ item.title }}
      </a>
    </div>
  </div>
</template>

<script>
import { getPcIndexEwm, getPcIndexEwm2 } from "@/apis/api";

export default {
  data() {
    return {
      ewmList: [],
      list2: [],
    };
  },
  created() {
    this.getPcIndexEwm();
    this.getPcIndexEwm2();
  },
  methods: {
    async getPcIndexEwm() {
      const { data } = await getPcIndexEwm();
      this.ewmList = data || [];
    },
    async getPcIndexEwm2() {
      const { data } = await getPcIndexEwm2();
      this.list2 = data || [];
    },
  },
};
</script>

<style lang="scss" scoped>
.fixed-right {
  z-index: 99;
  position: fixed;
  right: 24px;
  // top: 200px;
  // top: 26vh;
  top: calc(100vh - 530px);
  .item {
    position: relative;
    cursor: pointer;
    width: 52px;
    height: 52px;
    box-shadow: 1px 2px 8px rgba(0, 0, 0, 0.14);
    border-radius: 26px;
    margin-bottom: 20px;
    font-size: 0;
    .icon {
      // display: block;
      text-align: center;
      font-size: 12px;
      // font-size: var(--font-size-12);
      display: flex;
      align-items: center;
      justify-content: center;
      line-height: 1.2;
      height: 100%;
      color: #303133;
      background-color: #fff;
      border-radius: 50%;
      &.text {
        padding: 0 4px;
        color: #fff;
      }
      &.icon-color-0 {
        background-color: #feaf48;
      }
      &.icon-color-1 {
        background-color: #0d7ce4;
      }
    }
    .icon-img {
      width: 52px;
      height: 52px;
      object-fit: cover;
    }
    .ewm {
      display: none;
      position: absolute;
      right: 76px;
      top: 0;
      background-color: #fff;
      text-align: center;
      //   &.active {
      //     display: block;
      //   }
      padding: 10px;
      border-radius: 8px;
      box-shadow: 1px 2px 8px rgba(0, 0, 0, 0.14);
      &::after {
        content: "";
        position: absolute;
        right: -20px;
        top: 20px;
        border-width: 10px;
        border-style: solid;
        border-color: transparent transparent transparent #fff;
      }
      .img {
        width: 120px;
        height: 120px;
      }
      .tit {
        font-size: 16px;
        font-size: var(--font-size-16);
        font-weight: bold;
        line-height: 22px;
        color: #303133;
        margin-top: 6px;
        display: inline-block;
      }
    }
    &:hover .ewm {
      display: block;
    }
  }
}
</style>
